// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  AUTHENTIFICATION_AUTH_IN,
  AUTHENTIFICATION_AUTH_OUT,
  AUTHENTIFICATION_AUTH_EXPIRE
} from './constants';
import { API, Auth } from '../../../helper/api';
import { ROLE } from '../../admin/events/Constants';

export function logout() {
  return (dispatch) => {
    dispatch({
      type: AUTHENTIFICATION_AUTH_OUT,
    });

    API.setToken(null);
  }
}

export function checkLogin() {
  return (dispatch) => {
    if(Auth.isValid()){
      dispatch({
        type: AUTHENTIFICATION_AUTH_IN,
        data: Auth.parseJwt()
      });
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case AUTHENTIFICATION_AUTH_IN:
      return {
        ...state,
        isAuth: true,
        isAdmin: action.data && action.data.pk_user && action.data.pk_user.includes(ROLE.ADMIN),
        isYnov: action.data && action.data.pk_user && action.data.pk_user.includes(ROLE.STUDENT),
        isModerator: action.data && action.data.pk_user && action.data.pk_user.includes(ROLE.MODERATOR),
        user: action.data
      };
    
    case AUTHENTIFICATION_AUTH_OUT:
      return {
        ...state,
        isAuth: false,
        isAdmin: false,
        isYnov: false,
        isModerator: false,
        user: {}
      };
    
    case AUTHENTIFICATION_AUTH_EXPIRE:
      return {
        ...state,
        isAuth: false,
        isAdmin: false,
        isYnov: false,
        isModerator: false,
        user: {}
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/authentification/redux/auth.js